import React, { FC } from 'react';
import { useViewport } from '../../context';
import { TwoColumnLayout } from '../../components/layouts';
import { SitePreview } from './SitePreview/SitePreview';
import { SideContent } from './SitePreview/SideContent';
import { MobileSitePreview } from './MobileSitePreview/MobileSitePreview';

export interface SitePreviewWrapperProps {}

export const SitePreviewWrapper: FC<SitePreviewWrapperProps> = () => {
  const { isMobile } = useViewport();

  if (isMobile) {
    return <MobileSitePreview />;
  }

  return (
    <TwoColumnLayout
      mainContent={<SitePreview />}
      sideContent={<SideContent />}
      mainContentSpan={8}
      sideCellStyle={{ backgroundColor: '#FFFFFF' }}
    />
  );
};
